export enum TypeShippingRateType {
  FreeShipping = 'FreeShipping',
  National = 'National',
  ByState = 'ByState',
}
